import React from 'react';

import LoadingScreen from '../../components/LoadingScreen';

const SignOutPage = () => {
  return (
    <>
      <LoadingScreen />
    </>
  );
};

export default SignOutPage;
